const Trade = () => (
    <svg
        width='39'
        height='34'
        viewBox='0 0 39 34'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g>
            <path
                d='M13.8296 28.0282H17.5059V33.455H21.0071V28.0282H24.6833V0.544189H13.6543V28.0282H13.8296ZM17.5059 4.22015H21.0071V24.3522H17.5059V4.22015Z'
                fill='url(#paint0_linear_1001_3548)'
            />
            <path
                d='M38.5126 13.3232H34.8364V0.544189H31.1601V13.3232H27.4839V28.0282H31.1601V33.455H34.8364V28.0282H38.5126V13.3232Z'
                fill='url(#paint1_linear_1001_3548)'
            />
            <path
                d='M7.35247 0.543457H3.67624V7.89593H0V22.4261H3.67624V33.4551H7.35247V22.4261H11.0287V7.89593H7.35247V0.543457Z'
                fill='url(#paint2_linear_1001_3548)'
            />
        </g>
        <defs>
            <linearGradient
                id='paint0_linear_1001_3548'
                x1='13.6543'
                y1='16.9996'
                x2='24.6833'
                y2='16.9996'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' />
                <stop offset='1' stopColor='#00FFFF' />
            </linearGradient>
            <linearGradient
                id='paint1_linear_1001_3548'
                x1='27.4839'
                y1='16.9996'
                x2='38.5126'
                y2='16.9996'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' />
                <stop offset='1' stopColor='#00FFFF' />
            </linearGradient>
            <linearGradient
                id='paint2_linear_1001_3548'
                x1='0'
                y1='16.9993'
                x2='11.0287'
                y2='16.9993'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' />
                <stop offset='1' stopColor='#00FFFF' />
            </linearGradient>
        </defs>
    </svg>
);

export default Trade;
